import React,{useMemo} from 'react';
import {money} from '../../shared/UI';

const formatPeriod=(value,granularity)=>{
 if(granularity==='year')return String(value);
 const date=new Date(`${value}${granularity==='day'?'T12:00:00':'-01T12:00:00'}`);
 if(Number.isNaN(date.getTime()))return value;
 return new Intl.DateTimeFormat('es-MX',granularity==='day'?{day:'numeric',month:'short'}:{month:'short',year:'numeric'}).format(date);
};

export default function BankReportCharts({charts,source}){
 const periods=charts?.periodos||[];
 const banks=useMemo(()=>[...(charts?.bancos||[])].sort((a,b)=>Math.abs(Number(b.neto||0))-Math.abs(Number(a.neto||0))),[charts]);
 if(!periods.length&&!banks.length)return null;
 const maxPeriod=Math.max(1,...periods.flatMap(p=>[Number(p.abonos||0),Number(p.cargos||0)]));
 const maxBank=Math.max(1,...banks.map(b=>Math.abs(Number(b.neto||0))));
 const granularityLabel={day:'día',month:'mes',year:'año'}[charts.granularidad]||'periodo';
 const sourceNote=Number(source)===2?'MXN de movimientos conciliados con UXBI.':'Importes convertidos a MXN.';
 return <section className="finance-bank-charts" aria-label="Gráficas del reporte de bancos">
  <article className="finance-bank-chart">
   <div className="finance-bank-chart-heading"><div><h2>Abonos y cargos por {granularityLabel}</h2><p>{sourceNote}</p></div><div className="finance-chart-legend"><span><i className="finance-legend-credit"/>Abonos</span><span><i className="finance-legend-charge"/>Cargos</span></div></div>
   <div className="finance-chart-scroll" role="img" aria-label={`Abonos y cargos en MXN por ${granularityLabel}`}>
    {periods.map((item,index)=><div className="finance-period-entry" key={`${item.periodo}-${index}`}>
     <strong>{formatPeriod(item.periodo,charts.granularidad)}</strong>
     <div className="finance-period-series"><span>Abonos</span><div className="finance-period-track"><i className="finance-period-bar finance-legend-credit" style={{width:`${Math.max(0,Number(item.abonos||0))/maxPeriod*100}%`}}/></div><b>{money(item.abonos)}</b></div>
     <div className="finance-period-series"><span>Cargos</span><div className="finance-period-track"><i className="finance-period-bar finance-legend-charge" style={{width:`${Math.max(0,Number(item.cargos||0))/maxPeriod*100}%`}}/></div><b>{money(item.cargos)}</b></div>
    </div>)}
   </div>
  </article>
  <article className="finance-bank-chart">
   <div className="finance-bank-chart-heading"><div><h2>Saldo neto por banco</h2><p>Abonos menos cargos · MXN</p></div></div>
   <div className="finance-bank-rank" role="img" aria-label="Saldo neto en MXN por banco">
    {banks.map(bank=>{const net=Number(bank.neto||0),width=Math.abs(net)/maxBank*50;return <div className="finance-bank-rank-row" key={bank.id_banco}>
     <span className="finance-bank-name" title={bank.banco}>{bank.banco||'Sin banco'}</span>
     <div className="finance-bank-rank-track"><i className={`finance-bank-rank-bar ${net<0?'is-negative':'is-positive'}`} style={{left:`${net<0?50-width:50}%`,width:`${width}%`}}/></div>
     <b className={net<0?'text-danger':''}>{money(net)}</b>
    </div>;})}
   </div>
  </article>
 </section>;
}
